import NavBar from "./NavBar";
import Home from "./Home";
import About from "./About";
import Skills from "./Skills";
import Projects from "./Projects";
import Contact from "./Contact";

export const FullPage = ()=>{
    return(
        <>
            <NavBar />
            <Home />
            <About />
            <Skills />
            <Projects />
            <Contact />
        </>
    )
}